import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { getCookie } from '@bfe/by-storage';
import { getQueryParamsWithSpecialChars, getUrlObject, getMainDomainName, isFromInternalByMainDomain, pick } from '@bfe/by-helpers';
import ByLogger, { ByLoggerTables } from '@bfe/by-logger';
import { API2_HOST, AFFILIATES_HOST } from '@bfe/by-dynamic-domain';
import { getPlatformType } from '@bfe/by-browser-detector';
import { getLoggerInstance, getReportUrl, getGuid, cacheCookie, getTdId, setTdId, getUCache, getUid } from './utils';
var loggerHttpInstance = getLoggerInstance();
var reportUrl = getReportUrl();

var getChannelCookieKeyFromEnv = function getChannelCookieKeyFromEnv() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'local';
  return env === 'production' ? 'BYBIT_REG_REF' : "BYBIT_REG_REF_".concat(env);
};

var AFFILIATE_CLICK_ENDPOINT = "".concat(API2_HOST, "/s1/affiliate/click/add");
var WHITE_CLICK_ENDPOINT = "".concat(AFFILIATES_HOST, "/apiv2/click/add"); // 白标-统计链接点击次数 使用

var IGNORE_REG_DOMAIN = 'explorebybit.com';
var logger = new ByLogger({
  logTable: ByLoggerTables.STORE_SIGNUP,
  noBackgroundTasks: true,
  keepAliveInBackground: true,
  reportInterval: -1,
  reportDelay: 2000,
  reportUrl: reportUrl,
  extendFields: true,
  getGuid: getGuid,
  getUid: getUid
}, {
  act: 'channel_attr',
  t: 'traffic',
  p: getPlatformType,
  app_id: function app_id() {
    return window.APP_ID || 10000;
  },
  url: function url() {
    return window.location.href;
  },
  time: function time() {
    return new Date().getTime();
  },
  tdid: getTdId,
  u_cache: getUCache
});
logger.init();

var getReferrerUrlObj = function getReferrerUrlObj(referrerObj) {
  if (referrerObj) {
    var hostname = referrerObj.hostname,
        pathname = referrerObj.pathname,
        search = referrerObj.search;
    var referrer = "".concat(hostname).concat(pathname).concat(search);
    var source = getMainDomainName(hostname);
    return {
      referrer: referrer,
      source: source
    };
  }

  return {};
};
/**
 * Get correct saved channel info
 */


export var getChannelInfo = function getChannelInfo(env) {
  if (typeof window === 'undefined') return '';
  var channelCookieKey = getChannelCookieKeyFromEnv(env);
  var channelData = getCookie(channelCookieKey);
  var parsedChannelData = {};

  try {
    parsedChannelData = JSON.parse(channelData) || {};
  } catch (err) {
    // eslint-disable-next-line
    console.warn(err);
  }

  return parsedChannelData;
};
/**
 * Set correct channel logic to localStorage
 * And send landing event to logger.
 */

export var storeChannelInfo = function storeChannelInfo(env) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isWhite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (typeof window === 'undefined') return; // Preproces: Auto setup tdid and ucache

  setTdId();
  var referrerUrlObj = getUrlObject(document.referrer);
  var currentHost = window.location.hostname;
  var isFromInternal = referrerUrlObj && isFromInternalByMainDomain(currentHost, referrerUrlObj.hostname);
  var savedData = getChannelInfo(env) || {};
  var possibleSavedAffiliateId = savedData.affiliate_id;
  var possibleSavedRefData = savedData.ref;
  var queryParams = getQueryParamsWithSpecialChars(window.location);
  var affiliate_id = queryParams.affiliate_id,
      ref = queryParams.ref,
      utmsource = queryParams.utmsource;
  var isAffiliateSameAsStoredValue = possibleSavedAffiliateId === affiliate_id;
  var isRefSameAsStoredValue = possibleSavedRefData === ref;
  var noImpactUtmsourceQueryParam = utmsource !== 'impact'; // eslint-disable-next-line

  var isTopwindow = window === top.window;
  var hasChannelCookieData = Object.keys(savedData).length !== 0; // if REG cookie doesn't exist, we will always try to inject it.
  // (e.g. redirect from www.bybit.com to from www.bybit.com/en-US)

  if (isTopwindow && isFromInternal && hasChannelCookieData && isAffiliateSameAsStoredValue && isRefSameAsStoredValue && noImpactUtmsourceQueryParam) {
    return;
  }

  var ignoreDomain = currentHost.indexOf(IGNORE_REG_DOMAIN) >= 0;

  if (ignoreDomain) {
    return;
  }

  var channelCookieKey = getChannelCookieKeyFromEnv(env);
  var _queryParams$source = queryParams.source,
      source = _queryParams$source === void 0 ? opts.source : _queryParams$source,
      _queryParams$medium = queryParams.medium,
      medium = _queryParams$medium === void 0 ? opts.medium : _queryParams$medium,
      _queryParams$campaign = queryParams.campaign,
      campaign = _queryParams$campaign === void 0 ? opts.campaign : _queryParams$campaign; // eslint-disable-line

  var channelData = {
    stage: queryParams.stage,
    lang: queryParams.language || navigator.language,
    regist_channel: queryParams.regist_channel,
    term: queryParams.term,
    g: getGuid()
  };
  var logData;

  if (affiliate_id) {
    if (isAffiliateSameAsStoredValue) return;

    var commonData = _objectSpread(_objectSpread(_objectSpread({}, channelData), getReferrerUrlObj(referrerUrlObj)), {}, {
      medium: 'affiliate'
    });

    var affiliateData = pick(queryParams, ['affiliate_id', 'group_id', 'group_type']);

    var cookieData = _objectSpread(_objectSpread(_objectSpread({}, commonData), affiliateData), {}, {
      url: window.location.href,
      last_refresh_time: new Date().toUTCString()
    });

    logData = _objectSpread(_objectSpread({}, commonData), {}, {
      su: cookieData.affiliate_id
    });

    if (logData) {
      var url = isWhite ? WHITE_CLICK_ENDPOINT : AFFILIATE_CLICK_ENDPOINT; // Send affiliate link click event

      loggerHttpInstance.post(url, {
        body: JSON.stringify(affiliateData)
      }).catch();
    }

    cacheCookie(channelCookieKey, cookieData);
  } else if (ref) {
    if (isRefSameAsStoredValue) return;

    var _commonData = _objectSpread(_objectSpread(_objectSpread({}, channelData), getReferrerUrlObj(referrerUrlObj)), {}, {
      medium: 'referral'
    });

    var _cookieData = _objectSpread(_objectSpread(_objectSpread({}, _commonData), pick(queryParams, ['ref'])), {}, {
      url: window.location.href,
      last_refresh_time: new Date().toUTCString()
    });

    logData = _objectSpread(_objectSpread({}, _commonData), {}, {
      su: _cookieData.ref
    });

    if (!savedData.affiliate_id) {
      cacheCookie(channelCookieKey, _cookieData);
    }
  } else if (utmsource) {
    var _cookieData2 = _objectSpread(_objectSpread(_objectSpread({}, channelData), {
      medium: utmsource,
      utm_url: window.location.href,
      utm_data: Math.floor(new Date().getTime() / 1000) // current unix timestamp

    }), {}, {
      referrer: getReferrerUrlObj(referrerUrlObj).referrer,
      url: window.location.href,
      last_refresh_time: new Date().toUTCString()
    });

    logData = _cookieData2;

    if (!savedData.affiliate_id && !savedData.ref) {
      cacheCookie(channelCookieKey, _cookieData2);
    }
  } else if (source && medium) {
    var _cookieData3 = _objectSpread(_objectSpread(_objectSpread({}, channelData), pick(queryParams, ['content'])), {}, {
      source: source,
      medium: medium,
      campaign: campaign,
      referrer: getReferrerUrlObj(referrerUrlObj).referrer,
      url: window.location.href,
      last_refresh_time: new Date().toUTCString()
    });

    logData = _cookieData3;

    if (!savedData.affiliate_id && !savedData.ref && savedData.medium !== 'impact') {
      cacheCookie(channelCookieKey, _cookieData3);
    }
  } else {
    var _getReferrerUrlObj = getReferrerUrlObj(referrerUrlObj),
        fixedReferrer = _getReferrerUrlObj.referrer,
        fixedSource = _getReferrerUrlObj.source;

    var _cookieData4 = _objectSpread(_objectSpread({}, channelData), {}, {
      referrer: fixedReferrer,
      source: fixedSource,
      medium: fixedReferrer ? 'other' : 'direct',
      url: window.location.href,
      last_refresh_time: new Date().toUTCString()
    }); // If direct data exists, do not report again.


    logData = _cookieData4;
    if (!fixedReferrer && savedData.medium === 'other') return;

    if (!savedData.affiliate_id && !savedData.ref && !savedData.source && savedData.medium !== 'impact') {
      cacheCookie(channelCookieKey, _cookieData4);
    }
  }

  if (logData) logger.log(logData);
};